import { ActiveTradeNextOrder, TradeData } from "@shared/types";
import { formatDate } from "@shared/utils/date";
import { translateOptionName } from "@shared/common/i18n/optionNames";
import {
  checkTableRowSearch,
  getPercentSearchValues,
  TableSearchValue,
} from "utils/tableRowSearch";

const SEARCH_FIELDS = [
  "account",
  "exchange",
  "group",
  "trade_type",
  "trade_status",
  "close_reason",
  "margin_type",
  "Long/Short",
  "allocated_amount",
  "invested_amount",
  "allocated_amount_btc",
  "allocated_amount_usd",
  "invested_amount_btc",
  "invested_amount_usd",
  "allocated_quantity",
  "invested_quantity",
  "usd_amount_change",
  "btc_amount_change",
  "entry_price",
  "price",
  "price_when_closed",
  "risk_reward",
  "potential_profit",
] as const satisfies readonly (keyof TradeData)[];

const getOrderSearchValues = (
  order?: ActiveTradeNextOrder
): TableSearchValue[] =>
  order ? [order.price, getPercentSearchValues(order.distance * 100)] : [];

const getProgressSearchValues = (trade: TradeData): TableSearchValue[] => {
  const graph = trade.graph_data;
  if (!graph) return [];
  const profit = "profit" in graph ? graph.profit : undefined;
  return [Object.values(graph), getPercentSearchValues(profit)];
};

export const checkTradeSearch = (
  trade: TradeData,
  search?: string
): boolean => {
  if (!search?.trim()) return true;
  const orders = [trade.next_entry, trade.next_stop, trade.next_take_profit];
  return checkTableRowSearch(trade.symbol, search, [
    SEARCH_FIELDS.map((field) => trade[field]),
    translateOptionName(trade["Long/Short"]),
    translateOptionName(trade.margin_type),
    trade.leverage ? `${trade.leverage}x` : undefined,
    getProgressSearchValues(trade),
    orders.map(getOrderSearchValues),
    trade.timestamp ? formatDate(trade.timestamp, true, true) : undefined,
    trade.timestamp ? formatDate(trade.timestamp, true, true, true) : undefined,
  ]);
};
